/**
 * UnderConstructionBanner
 *
 * Fixed red bar at the top of every page, visible pre-launch, controlled
 * by the REACT_APP_UNDER_CONSTRUCTION build arg (CRA inlines this at
 * BUILD time, not runtime).
 *
 * Selector-stable for Playwright tests via data-testid.
 *
 * Flip to false on launch day:
 *   Railway → Service → Variables → REACT_APP_UNDER_CONSTRUCTION = false
 *   (and redeploy — CRA bakes this in at build time).
 *
 * Pair with the e2e smoke test (e2e/tests/smoke.spec.ts) which asserts this
 * banner is visible pre-launch.
 */

import React from 'react';

export default function UnderConstructionBanner() {
  // Read at module level — CRA replaces this with the literal string at
  // build time. Treat anything other than the string "true" as falsy.
  const enabled = process.env.REACT_APP_UNDER_CONSTRUCTION === 'true';

  if (!enabled) return null;

  return (
    <div
      data-testid="under-construction-banner"
      role="status"
      aria-live="polite"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 9999,
        width: '100%',
        background: 'var(--color-red-warn, #C8252C)',
        color: '#FFFFFF',
        textAlign: 'center',
        padding: '0.6rem 1rem',
        fontSize: '0.95rem',
        fontWeight: 700,
        letterSpacing: '0.02em',
        textTransform: 'uppercase',
        boxShadow: '0 1px 0 rgba(0, 0, 0, 0.15)',
      }}
    >
      Site under construction — not yet live
    </div>
  );
}
